export const create = (id, modelUrl, usdzModelUrl, placement) => ({
    _tag: 'Product',
    id,
    modelUrl,
    usdzModelUrl,
    placement,
});
